import { useEffect } from "react";
import { connect } from "react-redux";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import maplibregl from "maplibre-gl";

const LIBRE_GLB_BOGOR = ({ layer }) => {
  const { map_object } = layer;

  useEffect(() => {
    if (!map_object) return;
    const modelOrigin = [106.79044313594493, -6.595602867676217];
    const modelAltitude = 0;
    const modelRotate = [Math.PI / 2, 0, 0];
    const modelAsMercatorCoordinate = maplibregl.MercatorCoordinate.fromLngLat(
      modelOrigin,
      modelAltitude
    );

    const modelTransform = {
      translateX: modelAsMercatorCoordinate.x,
      translateY: modelAsMercatorCoordinate.y,
      translateZ: modelAsMercatorCoordinate.z,
      rotateX: modelRotate[0],
      rotateY: modelRotate[1],
      rotateZ: modelRotate[2],
      scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits(),
    };

    const customLayer = {
      id: "3d-station-bogor",
      type: "custom",
      renderingMode: "3d",
      onAdd: function (map, gl) {
        this.camera = new THREE.Camera();
        this.scene = new THREE.Scene();

        const light1 = new THREE.DirectionalLight(0xffffff);
        light1.position.set(0, -70, 100).normalize();
        this.scene.add(light1);

        const light2 = new THREE.DirectionalLight(0xffffff);
        light2.position.set(0, 70, 100).normalize();
        this.scene.add(light2);

        const loader = new GLTFLoader();
        loader.load(
          "https://maps-icons.s3.ap-southeast-3.amazonaws.com/3d-model/stasiun-bogor.glb",
          (gltf) => {
            this.scene.add(gltf.scene);
          },
          undefined,
          (error) => {
            console.error("Error loading Bogor GLB:", error);
          }
        );

        this.map = map;
        this.renderer = new THREE.WebGLRenderer({
          canvas: map.getCanvas(),
          context: gl,
          antialias: true,
        });
        this.renderer.autoClear = false;
      },
      render: function (gl, matrix) {
        const rotationX = new THREE.Matrix4().makeRotationAxis(
          new THREE.Vector3(1, 0, 0),
          modelTransform.rotateX
        );
        const rotationY = new THREE.Matrix4().makeRotationAxis(
          new THREE.Vector3(0, 1, 0),
          modelTransform.rotateY
        );
        const rotationZ = new THREE.Matrix4().makeRotationAxis(
          new THREE.Vector3(0, 0, 1),
          modelTransform.rotateZ
        );

        const m = new THREE.Matrix4().fromArray(
          matrix.defaultProjectionData.mainMatrix
        );
        const l = new THREE.Matrix4()
          .makeTranslation(
            modelTransform.translateX,
            modelTransform.translateY,
            modelTransform.translateZ
          )
          .scale(
            new THREE.Vector3(
              modelTransform.scale,
              -modelTransform.scale,
              modelTransform.scale
            )
          )
          .multiply(rotationX)
          .multiply(rotationY)
          .multiply(rotationZ);

        this.camera.projectionMatrix = m.multiply(l);
        this.renderer.resetState();
        this.renderer.render(this.scene, this.camera);
        this.map.triggerRepaint();
      },
    };

    const add3DLayer = () => {
      if (!map_object.getLayer("3d-station-bogor")) {
        map_object.addLayer(customLayer);
        map_object.flyTo({
          center: modelOrigin,
          zoom: 18,
          pitch: 60,
          speed: 2,
          curve: 1.5,
          easing: (t) => t,
        });
      }
    };

    if (map_object.isStyleLoaded()) {
      add3DLayer();
    } else {
      map_object.once("style.load", add3DLayer);
    }

    return () => {
      if (map_object.getLayer("3d-station-bogor")) {
        map_object.removeLayer("3d-station-bogor");
      }
    };
  }, [map_object]);

  return null;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
});

export default connect(mapStateToProps)(LIBRE_GLB_BOGOR);
